const WORKPAGE_COMPONENTS = {};

export default WORKPAGE_COMPONENTS;
